require('./brokerStocksPurchaseOrderStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const { AmountInput } = require('commonsComponents/amountInput');

// @components
const WizardStep = require('components/commons/wizardStep/wizardStep');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @constants
const {
  FIRST_STEP,
  EURO_TEXT
} = require('constants/index');
const CLASS_NAME = 'broker-stocks-purchase-order-step1';

class BrokerStocksPurchaseOrderStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(value) {
        this.props.onChangeAmount(value);
    }

    render() {
        const {
            immBrokerStocksPurchaseOrder,
            actions,
            cancelButton,
            nextButton
        } = this.props;
        const immFirstStep = immBrokerStocksPurchaseOrder.getIn(['steps', FIRST_STEP]);
        const amountLabel = formatText('stocksPurchaseOrder-amount', [EURO_TEXT]);
        const amount = immFirstStep.get('amount');
        const errorState = immFirstStep.getIn(['flagsError', 'amountError']);

        return (
            <WizardStep
                actions={actions}
                cancelButton={cancelButton}
                nextButton={nextButton}
                position="first"
            >
                <h4 className={`${CLASS_NAME}__header-title`}>
                    <FormattedText
                        value="stocksPurchaseOrder-purchaseInformation"
                    />
                </h4>
                <div className={`${CLASS_NAME}__info`}>
                    <FormattedText
                        value="stocksPurchaseOrder-completeFollowingInformation"
                    />
                </div>
                <div className={`${CLASS_NAME}__field`}>
                    <div className={`${CLASS_NAME}__input`}>
                        <AmountInput
                            label={amountLabel}
                            amount={amount}
                            callback={this.onChange}
                            language={getLanguage()}
                            error={errorState}
                            errorMsg={formatText('corporatesOperations-OPVamountError')}
                        />
                    </div>
                </div>
            </WizardStep>
        );
    }
}

BrokerStocksPurchaseOrderStep1.propTypes = {
    immBrokerStocksPurchaseOrder: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onChangeAmount: PropTypes.func.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool
};

BrokerStocksPurchaseOrderStep1.defaultProps = {
    cancelButton: true,
    nextButton: true
};

module.exports = BrokerStocksPurchaseOrderStep1;